import { IConfig } from '@cian/config/shared';

export const isWebView = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('web.isWebView')) || false;
};
